import { AreaChart, BarChart } from "@tremor/react";
import { ResponsiveContainer } from "recharts";

export default function Chart({ data, capability }) {
  const getChartProps = () => {
    const baseProps = {
      data,
      index: "date",
      valueFormatter: (value) => {
        if (typeof value !== 'number' || isNaN(value)) {
          return `${value || '0'} ${capability.unit}`;
        }
        return `${value.toFixed(2)} ${capability.unit}`;
      },
      categories: ["Measurement"],
      colors: ["blue"],
      noDataText: "No data for the last 24 hours",
      showXAxis: true,
      showGridLines: false,
      startEndOnly: true,
      showYAxis: capability.widget.showYAxis || false,
      showLegend: false,
      showAnimation: true,
    };

    // Add Y-axis bounds if configured
    if (capability.widget.yMin !== undefined) {
      baseProps.minValue = capability.widget.yMin;
    }
    if (capability.widget.yMax !== undefined) {
      baseProps.maxValue = capability.widget.yMax;
    }

    return baseProps;
  };

  return (
    <ResponsiveContainer height={"70%"}>
      {/* chart types */}
      {
        capability.widget.type === "areachart" ? (
          <AreaChart {...getChartProps()} />
        ) : capability.widget.type === "barchart" ? (
          <BarChart className="barhop" {...getChartProps()} />
        ) : (
          <div />
        )

        // Fallback to an empty div or another chart if none matches
      }
    </ResponsiveContainer>
  );
}
